import Vue from '@/index.js'
import page from '@/mixins/page'

// Подключение стилей только для этой страницы
require('./page.scss')

const components = {
  productGallery: () => import('@/components/product/product-gallery.vue'),
  productGalleryThumb: () => import('@/components/product/product-gallery-thumb.vue'),
  productGallerySlide: () => import('@/components/product/product-gallery-slide.vue'),
  Slider: () => import('@/components/index/slider.vue'),
  NestedSlider: () => import('@/components/product/nested-slider.vue'),
  Slide: () => import('@/components/index/slide.vue')
}


export default new Vue({
  mixins: [page],
  el: '#app',
  data () {
    return {
      amount: 1,
      price: 0,
      fullscreen: false
    }
  },
  components,
  methods: {
    async addToCart ($event) {
      //  const variant = document.querySelector('input[name=variant]:checked').value
      const form = $event.target
      const action = form.action
      const formData = new FormData(form)
      let sidebarCart = window['__sidebar__'].cart
      const cartLabel = Number(sidebarCart.label)
      const amount = cartLabel + Number(form.amount.value)
      sidebarCart.label = `${amount}`

      await this.$axios.post(action, formData).then(response => {
        sidebarCart.items = JSON.parse(response.data)
      })
    },
    async addToFav () {
      const variant = document.querySelector('input[name=variant]:checked').value
      const sidebarFav = window['__sidebar__'].favorites
      const action = sidebarFav.action
      const form = {
        act: "add",
        variant: variant
      }

      let formData = new FormData()
      Object.keys(form).forEach(key => formData.append(key, form[key]));
      await this.$axios.post(action, formData).then(response => {
        sidebarFav.items = JSON.parse(response.data)
        sidebarFav.label = `${sidebarFav.items.length}`
      })

    },
    async fastOrder () {
      const variant = document.querySelector('input[name=variant]:checked').value
      const name = document.querySelector('.page-title').innerHTML
      const color = document.querySelector(`input[name=variant]:checked`).dataset.color
      const colorName = document.querySelector(`input[name=variant]:checked`).dataset.colorname
      this.$bus.$emit('fastOrder',{
        name: name,
        color: color,
        colorName: colorName,
        variant: variant
      })
    },
    changePrice (id, price, compare_price) {
      document.querySelector('.price span').innerHTML = price


      if (compare_price==0) {
        document.querySelector('.compare_price').innerHTML = ''
      } else if (compare_price) {
        document.querySelector('.compare_price').innerHTML = compare_price
      } else {
        document.querySelector('.compare_price').innerHTML = ''
      }
      
      this.$bus.$emit('change-color',{
        id: id
      })
      // console.log( document.querySelectorAll('[variant="'+ id+ '"]')[0]);
    },
    fullscreenToggle () {

      this.fullscreen = !this.fullscreen
      // this.cacheGalleryTop.update()
    }
  }
})
